<template>
  <div class="today-alarm">
    <resize-container :tabShow="tabShow">
      <div class="grid-content box" v-show="tabShow" slot="left">
        <tab-tree
          :data="viewTreeData"
          @tabTreeDefault="tabTreeDefault"
          @changeCompany="changeCompany"
          @tabTreeClick="tabTreeClick"
        ></tab-tree>
      </div>
      <div class="grid-rightcontent">
        <div class="box bgbox">
          <div class="time_box">
            <time-search
              ref="timeSearch"
              :control="{ data: timeData }"
              @timeControlClick="getSearchElem"
            >
            </time-search>
          </div>
          <div
            class="contant_box setHeight"
            v-loading="loadingData"
            element-loading-text="数据正在加载中"
          >
            <div class="barTop">
              <el-col
                :span="16"
                style="padding-left:0;padding-right:10px;height:100%"
              >
                <div style="height:100%">
                  <bar :barDate1="barDate1"></bar>
                </div>
              </el-col>
              <el-col :span="8" style="height:100%">
                <div style="height:100%">
                  <guan :pie="pie"></guan>
                </div>
              </el-col>
            </div>
            <!-- style="height:49%;margin-top:20px" -->
            <div class="barbottom">
              <el-col :span="16" class="barTopleft" style="height:100%">
                <nk-table
                  :showPage="false"
                  :columns="columns"
                  :maxHeight="400"
                  :data="tableData1"
                  style="height: 100%;
                  overflow: auto;"
                ></nk-table>
              </el-col>
              <el-col :span="8" class="barTopright" style="height:100%">
                <guanf :pie1="pie1"></guanf>
              </el-col>
            </div>
          </div>
        </div>
      </div>
    </resize-container>
  </div>
</template>
<script>
import TabTree from "@/components/common/TabTree.vue";
import BtnShow from "@/components/common/BtnShow.vue";
import api from "@common/api/index.js";
import { findDataByParam } from "@/utils/index";
import * as fpg from "@/utils/fpg";
import * as utils from "@/utils/index";
import DataType from "@/components/common/datatype";
import NkTable from "@/components/common/NkTable.vue";
import NkChart from "@/components/common/NkChart18.vue";
import Bar from "./page/bar.vue";
import Guan from "./page/guan.vue";
import Guanf from "./page/guanf.vue";
import handleData from "@/utils/handleData";
import TimeSearch from "@/components/common/TimeSearch.vue";
import dateTool from "@/utils/dateTool";
import { isNull } from "util";
import ResizeContainer from "@/components/common/resizeContainer.vue";
import dayjs from "dayjs";
let allTimeData = [
  {
    type: "month",
    label: "月",
  },
  {
    type: "year",
    label: "年",
  },
];
export default {
  components: {
    TabTree,
    BtnShow,
    DataType,
    NkTable,
    NkChart,
    Bar,
    Guan,
    Guanf,
    TimeSearch,
    ResizeContainer,
  },
  computed: {},
  data() {
    return {
      timeData: allTimeData,
      tabShow: true,
      viewTreeData: [],
      selectedMeasure: {
        measureId: "",
        measureName: "",
      },

      harmonic: 0,

      tableData: [],
      chartDataV: [],
      chartDataA: [],
      unit: "",
      timeTitle: "",
      showEleWork: false,
      eleWorkObj: {},
      measure: [],
      isDoubleY: false,
      selectNodes: [],

      //-----------------------------------------------------
      timeType: [
        { value: "2", label: "月" },
        { value: "5", label: "年" },
      ],
      tableData1: [],
      tableData2: [],
      columns: [
        { prop: "total", width: 200, label: "日期" },
        { prop: "fValue", label: "峰期电(元)" },
        { prop: "pValue", label: "平期电(元)" },
        { prop: "gValue", label: "谷期电(元)" },
        { prop: "jValue", label: "尖期电(元)" },
        { prop: "sum", label: "电度电费(元)" },
      ],
      alarnclass: "alarnclass", //时段需要选分秒
      dataType: "0",
      elem: { dataType: "0", dateType: "0", fromDate: "", toDate: "" },
      timeInterval: "toDay",
      barDate: {
        xdata: [],
        seriesData: [
          { time: [] },
          { time: [] },
          { time: [] },
          { time: [] },
          { time: [] },
        ],
      }, //柱状图数据
      barDate1: {
        xdata: [],
        seriesData: [[], [], [], [], []],
        time: [],
        measureName: "",
        barDatedd: {},
        type: "df",
      },
      barDatedd: {
        xdata: [],
        seriesData: [[], [], [], [], []],
        dateType: "",
      },
      barDatedd1: {
        xdata: [],
        seriesData: [[], [], [], [], []],
        dateType: "",
      },
      pie: {}, //饼图数据用量
      pie1: {}, //饼图数据费用
      pie2: {}, //饼图数据用量
      pie3: {}, //饼图数据费用
      pointCode: "100229",
      pointNumber: "0",
      measureId: "", //计量点
      apiArr: [],
      fValue: "", //峰
      pValue: "", //平
      gValue: "", //谷
      jValue: "", //尖
      fromDate: "",
      toDate: "",
      loadingData: false,
    };
  },
  created() {
    let vm = this;
  },
  mounted() {
    let vm = this;
  },
  methods: {
    changeCompany(companyId) {
      api.frontEndPageCustomParam
        .getMyFrontEndPageCustomParam(companyId, "/analysis/fpgtjdf", null)
        .then((res) => {
          const viewTreeData = findDataByParam("viewTree", true, res.data);
          this.viewTreeData = viewTreeData;
        });
    },
    tabTreeDefault(e) {
      let vm = this;
      vm.selectedMeasure = e;
      let defaultNode = e;
      vm.selectNodes = [
        { id: defaultNode.measureId, label: defaultNode.measureName },
      ];
      vm.measureId = e.measureId;
      let time = new Date();
      let startTime = dateTool.format(time, "yyyy-MM-") + "01 00:00:00";
      time.setMonth(time.getMonth() + 1);
      let endTime = dateTool.format(time, "yyyy-MM-") + "01 00:00:00";
      vm.elem = {
        dataType: "1",
        dateType: "month",
        endTime: endTime,
        startTime: startTime,
      };
      vm.getSearchElem(vm.elem);
    },
    tabTreeClick(data) {
      let vm = this;
      vm.selectNodes = [{ id: data.measureId, label: data.measureName }];
      vm.measureId = data.measureId;
      vm.getSearchElem(vm.elem);
    },

    formatDate(date, fmt) {
      date = date || new Date();
      fmt = fmt || "yyyy-MM-dd hh:mm:ss";
      if (Object.prototype.toString.call(date).slice(8, -1) !== "Date") {
        date = new Date(date.replace(/-/g, "/"));
      }
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      let o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds(),
      };
      for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          let str = o[k] + "";
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length === 1 ? str : this.padLeftZero(str)
          );
        }
      }
      return fmt;
    },
    padLeftZero(str) {
      return ("00" + str).substr(str.length);
    },
    /**
     * 点击查询事件
     */
    getSearchElem(elem) {
      this.loadingData = true;
      let vm = this;
      vm.elem = elem;
      // //生成这个月的天
      let xData = [];
      let startDate = new Date(elem.startTime.replace(/-/g, "/"));
      let thisDate = new Date(
        startDate.getFullYear(),
        startDate.getMonth() + 1,
        0
      ); //当天数为0 js自动处理为上一月的最后一天
      let days = thisDate.getDate();
      for (let index = 0; index < days; index++) {
        let thisDate = new Date(startDate);
        thisDate.setDate(index + 1);
        xData.push({
          title: index + 1,
        });
      }
      vm.tableData2 = [];
      if (elem.dateType == "month") {
        for (let i = 0; i < xData.length; i++) {
          vm.tableData2.push({
            total: xData[i].title,
            sum: null,
            fValue: null,
            pValue: null,
            gValue: null,
            jValue: null,
          });
          vm.tableData2[i].total = xData[i].title;
        }
      } else if (elem.dateType == "year") {
        for (let i = 0; i < 12; i++) {
          vm.tableData2.push({
            total: i + 1,
            sum: null,
            fValue: null,
            pValue: null,
            gValue: null,
            jValue: null,
          });
        }
      }

      vm.tableData2[vm.tableData2.length] = {
        total: "合计",
        sum: null,
        fValue: null,
        pValue: null,
        gValue: null,
        jValue: null,
      };
      // vm.elem.fromDate.s;
      elem.dataType = vm.dataType;
      vm.barDatedd.dateType = elem.dateType;
      vm.barDate1.dateType = elem.dateType;
      vm.elem = elem;
      let getNextTime = fpg.getNextTime(vm.elem.dateType); //拿取上一时间段的值
      let str = new Date(vm.elem.startTime.replace(/-/g, "/"));
      str.setDate(str.getDate() + 1);
      let endTime = dateTool.format(str, "yyyy-MM-dd") + " 00:00:00";
      let timeData = JSON.parse(
        JSON.stringify(
          fpg.getMatchTime(elem.startTime, elem.endTime, elem.dateType)
        )
      ); //匹配查询时间
      let currentTime = [];
      if (elem.dateType == "year") {
        currentTime = JSON.parse(
          JSON.stringify(
            fpg.getCurrentMatchTime(elem.startTime, elem.endTime, elem.dateType)
          )
        ); //匹配当前时间
      } else {
        currentTime = JSON.parse(
          JSON.stringify(
            fpg.getMatchTime(elem.startTime, endTime, elem.dateType)
          )
        ); //查月時拿每月第一天,查年時每年第一天
      }
      vm.barDate.seriesData[0].time = timeData;
      vm.barDate.seriesData[1].time = timeData;
      vm.barDate.seriesData[2].time = timeData;
      vm.barDate.seriesData[3].time = timeData;
      vm.barDate.seriesData[4].time = timeData;
      vm.barDatedd1.seriesData[0].time = currentTime;
      vm.barDatedd1.seriesData[1].time = currentTime;
      vm.barDatedd1.seriesData[2].time = currentTime;
      vm.barDatedd1.seriesData[3].time = currentTime;
      vm.barDatedd1.seriesData[4].time = currentTime;
      vm.barDate1.time = timeData;
      let xdata1 = handleData.createXData(
        vm.elem.dateType,
        vm.elem.startTime,
        vm.elem.endTime
      ); //获取柱状图x轴
      let dt = "";
      if (vm.elem.dateType == "month") {
        dt = "0";
      } else {
        dt = "2";
      }
      let xdata2 = handleData.createXData(dt, vm.fromDate, vm.toDate); //获取柱状图x轴
      vm.barDate1.xdata = [];
      vm.barDatedd.xdata = [];
      for (let i = 0; i < xdata1.length; i++) {
        vm.barDate1.xdata.push(xdata1[i].title);
      }
      for (let i = 0; i < xdata2.length; i++) {
        vm.barDatedd.xdata.push(xdata2[i].title);
      }
      vm.apiArr = [];
      // vm.apiArr.push(
      //   vm.$api.cost.getSpentMoney(
      //     vm.measureId,
      //     vm.elem.startTime,
      //     vm.elem.endTime,
      //     vm.pointCode,
      //     vm.pointNumber,
      //     1,
      //     ""
      //   ) //谷
      // );
      // if (vm.elem.dateType == "day") {
      //   vm.apiArr.push(
      //     vm.$api.cost.getSpentMoneyHour(
      //       vm.measureId,
      //       vm.elem.startTime,
      //       vm.elem.endTime,
      //       vm.pointCode,
      //       vm.pointNumber,
      //       1,
      //       ""
      //     ) //峰，平，谷。总费
      //   );
      // } else
      if (vm.elem.dateType == "month") {
        vm.apiArr.push(
          vm.$api.cost.getSpentMoneyMonth(
            vm.measureId,
            vm.elem.startTime,
            dayjs(vm.elem.startTime)
              .endOf("M")
              .format("YYYY/MM/DD HH:mm:ss"),
            vm.pointCode,
            vm.pointNumber,
            1,
            ""
          ) //峰，平，谷。总费
        );
        vm.apiArr.push(
          vm.$api.cost.getSpentMoneyDay(
            vm.measureId,
            vm.elem.startTime,
            dayjs(vm.elem.startTime)
              .endOf("M")
              .format("YYYY/MM/DD HH:mm:ss"),
            vm.pointCode,
            vm.pointNumber,
            1,
            1
          ) //峰，平，谷。总费
        );
      } else {
        vm.apiArr.push(
          vm.$api.cost.getSpentMoneyYear(
            vm.measureId,
            dayjs(vm.elem.startTime)
              .startOf("year")
              .format("YYYY/MM/DD HH:mm:ss"),
            dayjs(vm.elem.startTime)
              .endOf("year")
              .format("YYYY/MM/DD HH:mm:ss"),
            vm.pointCode,
            vm.pointNumber,
            1,
            ""
          ) //峰，平，谷。总费
        );
        vm.apiArr.push(
          vm.$api.cost.getSpentMoneyMonth(
            vm.measureId,
            dayjs(vm.elem.startTime)
              .startOf("year")
              .format("YYYY/MM/DD HH:mm:ss"),
            dayjs(vm.elem.startTime)
              .endOf("year")
              .format("YYYY/MM/DD HH:mm:ss"),
            vm.pointCode,
            vm.pointNumber,
            1,
            ""
          ) //峰，平，谷。总费
        );
      }
      vm.getEDate();
    },
    //获取数据
    getEDate() {
      let vm = this;
      Promise.all(vm.apiArr).then((res) => {
        let barDate1 = JSON.parse(JSON.stringify(vm.barDate1));
        res[0].data = { detail: res[0].data.map((k) => k.detail[0]) };
        fpg.getEcharts(res[0].data, "pie"); //拿取当前饼图用电量,电费
        vm.pie2 = {
          yester: [
            {
              value: res[0].data.fValue == "-" ? 0 : res[0].data.fValue,
              name: "峰期用电量",
            },
            {
              value: res[0].data.pValue == "-" ? 0 : res[0].data.pValue,
              name: "平期用电量",
            },
            {
              value: res[0].data.gValue == "-" ? 0 : res[0].data.gValue,
              name: "谷期用电量",
            },
            {
              value: res[0].data.jValue == "-" ? 0 : res[0].data.jValue,
              name: "尖期用电量",
            },
          ],
          dateType: vm.elem.dateType,
        };
        vm.pie3 = {
          yester: [
            {
              value: res[0].data.fValue1 == "-" ? 0 : res[0].data.fValue1,
              name: "峰期用电费",
            },
            {
              value: res[0].data.pValue1 == "-" ? 0 : res[0].data.pValue1,
              name: "平期用电费",
            },
            {
              value: res[0].data.gValue1 == "-" ? 0 : res[0].data.gValue1,
              name: "谷期用电费",
            },
            {
              value: res[0].data.jValue1 == "-" ? 0 : res[0].data.jValue1,
              name: "尖期用电量",
            },
          ],
          dateType: vm.elem.dateType,
        };
        let searchRes = []; //查询时间接口数据
        let searchCurrentRes = []; //当前时间接口
        searchRes = res[1].data;
        fpg.getEcharts(searchRes, "bar"); //拿取当前柱状图用电量,电费
        vm.barDate.seriesData[0].time = fpg.timeChabge1(
          vm.barDate.seriesData[0].time,
          searchRes,
          "f"
        ); //转换峰数据  拿当前月的
        vm.barDate.seriesData[1].time = fpg.timeChabge1(
          vm.barDate.seriesData[1].time,
          searchRes,
          "p"
        ); //转换平数据
        vm.barDate.seriesData[2].time = fpg.timeChabge1(
          vm.barDate.seriesData[2].time,
          searchRes,
          "g"
        ); //转换谷数据
        vm.barDate.seriesData[3].time = fpg.timeChabge1(
          vm.barDate.seriesData[3].time,
          searchRes,
          "j"
        ); //转换尖数据
        vm.barDate.seriesData[4].time = fpg.timeChabge1(
          vm.barDate.seriesData[4].time,
          searchRes,
          "total"
        ); //转换谷数据
        let sum = null;
        for (let i = 0; i < searchRes.length; i++) {
          //拿取表格数据
          let item = searchRes[i];
          const index =
            vm.elem.dateType === "month"
              ? dayjs(item.time).date() - 1
              : dayjs(item.time).month();

          if (
            vm.tableData2[index] != null &&
            vm.tableData2[index] != undefined
          ) {
            vm.tableData2[index].fValue = item.fValue1;
            vm.tableData2[index].pValue = item.pValue1;
            vm.tableData2[index].gValue = item.gValue1;
            vm.tableData2[index].jValue = item.jValue1;
          }
          if (item.value) {
            if (vm.tableData2[index] != null) {
              vm.tableData2[index].sum = item.value.toFixed(2);
            }
          }
        }
        const obj = vm.tableData2.reduce(
          (p, n) => {
            if (n.fValue && n.fValue !== "-") {
              p.fing += +n.fValue;
            }
            if (n.pValue && n.pValue !== "-") {
              p.ping += +n.pValue;
            }
            if (n.gValue && n.gValue !== "-") {
              p.gu += +n.gValue;
            }
            if (n.jValue && n.jValue !== "-") {
              p.jian += +n.jValue;
            }
            if (n.sum && n.sum !== "-") {
              p.eleFree += +n.sum;
            }
            return p;
          },
          {
            fing: 0,
            ping: 0,
            gu: 0,
            jian: 0,
            eleFree: 0,
          }
        );

        vm.tableData2[vm.tableData2.length - 1].fValue = obj.fing?.toFixed(2);
        vm.tableData2[vm.tableData2.length - 1].pValue = obj.ping?.toFixed(2);
        vm.tableData2[vm.tableData2.length - 1].gValue = obj.gu?.toFixed(2);
        vm.tableData2[vm.tableData2.length - 1].jValue = obj.jian?.toFixed(2);
        vm.tableData2[vm.tableData2.length - 1].sum = obj.eleFree?.toFixed(2);
        barDate1.seriesData = [[], [], [], [], []];
        vm.barDatedd.seriesData = [[], [], [], [], []];
        for (let i = 0; i < vm.barDate.seriesData.length; i++) {
          for (let j = 0; j < vm.barDate.seriesData[i].time.length; j++) {
            barDate1.seriesData[i].push(vm.barDate.seriesData[i].time[j].value);
          }
        }
        for (let i = 0; i < vm.barDatedd1.seriesData.length; i++) {
          for (
            let j = 0;
            j < vm.barDatedd1.seriesData[i].time.length;
            j++
          ) {
            vm.barDatedd.seriesData[i].push(
              vm.barDatedd1.seriesData[i].time[j].value
            );
          }
        }
        barDate1.barDatedd = vm.barDatedd;
        barDate1.barDatedd1 = vm.barDatedd1;
        let arr = JSON.parse(JSON.stringify(vm.tableData2));
        vm.barDate1 = JSON.parse(JSON.stringify(barDate1));
        arr.forEach((item, i) => {
          /* 最后一项合计不要添加东西 */
          if (i != arr.length - 1) {
            if (vm.elem.dateType == "month") {
              item.total = item.total + "号";
            } else {
              item.total = item.total + "月";
            }
          }
        });
        vm.tableData1 = arr;
        vm.pie = vm.pie2;
        vm.pie1 = vm.pie3;
        this.loadingData = false;
      });
    },
    //树加载
    bindGetTreeTabCode(e) {
      let vm = this;
      vm.$api.view.getViewTreeNodes(e.code).then((res) => {
        let arr = [];
        let nodes = [];
        for (let index = 0; index < res.data.length; index++) {
          const element = res.data[index];
          arr.push(element.measureId);
          nodes.push({
            id: element.measureId,
            label: element.measureName,
          });
        }
        setTimeout(() => {
          vm.$refs.tree.setTreeNodeSelect(vm.leftTreeData[0].children[0].id); //默认选择第一个节点
        }, 100);
        vm.leftTreeData = utils.creatTreeData(res.data, 0);
        vm.elem = vm.$refs.search.getElem();
        vm.measureId = vm.leftTreeData[0].children[0].id;
        vm.barDate1.measureId = vm.leftTreeData[0].id;
        vm.getSearchElem(vm.elem);
      });
    },
    //树点击事件
    bindTreeClick(data) {
      let vm = this;
      vm.measureId = data.id;
      vm.barDate1.measureId = data.id;
      vm.getSearchElem(vm.elem);
    },
    //获取时段
    getTimeSegmentsGroup() {
      this.$api.view.getTimeSegmentsGroup(0).then((res) => {
        this.getDutyTables(res.data[0].id);
      });
    },
    //获取峰平谷数据
    getDutyTables(e) {
      let vm = this;
      vm.$api.view.getTimeSegments(e).then((res) => {
        if (res.success) {
          for (let i = 0; i < res.data.length; i++) {
            vm.fValue = res.data[0].id;
            vm.pValue = res.data[1].id;
            vm.gValue = res.data[2].id;
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.bgbox {
  position: relative;
  padding-top: 0;
  box-sizing: border-box;
  padding: 0;
  background: transparent;
}
.time_box {
  width: 100%;
  background: #fff;
  border-radius: 5px;
}
.contant_box {
  position: absolute;
  background: #fff;
  top: 65px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  padding: 14px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: 1px solid #eee;
  border-radius: 5px;
}
.box_btn {
  height: 40px;
  width: 100%;
  line-height: 40px;
  display: flex;
  align-items: flex-end;
  border-bottom: 2px solid #00368e;
}
.box_btn p {
  font-size: 14px;
  color: #000;
  height: 30px;
  width: 96px;
  line-height: 30px;
  text-align: center;
  border: 1px solid #f5f5f5;
  border-bottom: none;
  cursor: pointer;
}
.box_btn .active {
  background: #00368e;
  color: #fff;
}
.box_con {
  position: absolute;
  top: 50px;
  bottom: 0px;
  width: 100%;
  display: flex;
}
.box_con_ {
  position: absolute;
  top: 45px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  overflow: hidden;
}
.chart_box {
  position: absolute;
  top: 10px;
  width: 100%;
  height: 600px;
  overflow: hidden;
}
.table_box {
  position: absolute;
  top: 615px;
  width: 100%;
  height: auto;
}
.charts {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.elechart_box {
  width: 100%;
  height: auto;
}
.eletable_box {
  width: 100%;
  height: auto;
}
.barTop {
  height: 49%;
}
.barTopleft {
  padding-left: 0;
  padding-right: 10px;
}
.barTopright {
  padding-right: 0;
}
.barbottom {
  height: 49%;
  margin-top: 20px;
}

::v-deep .echarts-warp {
  padding: 0px !important;
  border: none !important;
}
::v-deep .echart-content {
  padding-top: 20px !important;
}
.today-alarm {
  padding: 14px;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
}
.person {
  height: 100%;
}
.grid-content {
  position: relative;
  height: 100%;
  color: rgba(24, 24, 24, 1);
  overflow: auto;
  border-radius: 4px;
}
.grid-rightcontent {
  position: relative;
  height: 100%;
  color: rgba(24, 24, 24, 1);
  display: flex;
  flex-direction: column;
  .timeselect {
    padding: 5px 10px;
  }
  .pane {
    text-align: left;
    padding: 15px 0px;
    overflow: auto;
  }
}
</style>
